import React, { Component, ReactNode, MouseEvent as ReactMouseEvent } from "react";
import classnames from "classnames";

export interface IDialogToolProps {
    className?: string;
    onClick: (e: ReactMouseEvent) => void;
    children?: ReactNode[] | ReactNode;
    testId?: string;
}
export class DialogTool extends Component<IDialogToolProps> {
    render(): JSX.Element {
        const { className, children, onClick, testId } = this.props;
        return (
            <span
                className={classnames("dialog-tool-icon", className)}
                onClick={(e: ReactMouseEvent) => onClick(e)}
                {...(testId ? { "data-testid": testId } : {})}
            >
                {children}
            </span>
        );
    }
}
